var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.drawer,
            size: "90%",
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "form-center",
            },
            [
              _c("div", { staticClass: "formInfo" }, [
                _vm.item.WorkOrderState == 0 || _vm.item.WorkOrderState == 3
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-bottom": "10px",
                          "font-size": "14px",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.item.LogContent) + " ")]
                    )
                  : _vm._e(),
                _vm.item.WorkOrderState == 0 || _vm.item.WorkOrderState == 3
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-divider",
                          { attrs: { "content-position": "left" } },
                          [_vm._v("工单信息")]
                        ),
                        _c("EditForm", {
                          ref: "EditForm",
                          attrs: { isLog: true },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "formTime" },
                [
                  _c(
                    "el-timeline",
                    _vm._l(_vm.dataList, function (item, index) {
                      return _c(
                        "el-timeline-item",
                        {
                          key: item.Id,
                          attrs: {
                            timestamp: `${item.Title || ""} ${
                              item.LogTime
                                ? _vm
                                    .moment(item.LogTime)
                                    .format("YYYY-MM-DD HH:mm")
                                : ""
                            }`,
                            placement: "top",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "dot",
                              attrs: { slot: "dot" },
                              slot: "dot",
                            },
                            [_vm._v(" " + _vm._s(index + 1) + " ")]
                          ),
                          _c("el-card", [
                            item.WorkOrderState == 3
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#409eff",
                                      "border-bottom": "1px solid #409eff",
                                      cursor: "pointer",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlePreview(item)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(item.LogContent))]
                                )
                              : _c("span", [_vm._v(_vm._s(item.LogContent))]),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "footer" },
            [
              _c(
                "el-button",
                { attrs: { loading: _vm.loading }, on: { click: _vm.close } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("Log", { ref: "Log", attrs: { isLog: true } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }